import { useState } from 'react';
import Button from '@/components/primitives/Button.jsx';
import Input from '@/components/primitives/Input.jsx';
import Select from '@/components/primitives/Select.jsx';
import Dialog from '@/components/patterns/Dialog.jsx';
import toastManager from '@/lib/toast/toastManager.js';
import { getMembers, inviteMembers } from '@/redux/requests/membersRequests.js';

/** Invites one person by email with a role; they get an email with a link to join. */
const InviteMemberDialog = ({ open, onOpenChange, roleItems, defaultRoleId, organizationName }) => {
  const [email, setEmail] = useState('');
  const [roleId, setRoleId] = useState(null);
  const [error, setError] = useState('');
  const [isInviting, setIsInviting] = useState(false);

  const selectedRoleId = roleId ?? defaultRoleId ?? null;

  /* Closing clears what was typed, so the dialog opens clean next time. */
  const handleOpenChange = (next) => {
    if (!next) {
      setEmail('');
      setRoleId(null);
      setError('');
    }
    onOpenChange(next);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsInviting(true);
    const res = await inviteMembers({ invites: [{ email: email.trim(), roleId: selectedRoleId }], signupSource: 'pieve' });
    setIsInviting(false);

    if (res?.success === false) {
      setError(res.message || 'The invite could not be sent.');
      return;
    }

    await getMembers();
    toastManager.add({ type: 'success', title: 'Invite sent', description: `${email.trim()} can join ${organizationName} from the email.` });
    handleOpenChange(false);
  };

  return (
    <Dialog
      open={open}
      onOpenChange={handleOpenChange}
      title={`Invite to ${organizationName}`}
      description="They get an email with a link to set a password and join. The role decides what they can see and change."
      footer={
        <>
          <Button variant="ghost" onClick={() => handleOpenChange(false)}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" form="invite-member" loading={isInviting} disabled={!email.trim() || !selectedRoleId}>
            Send invite
          </Button>
        </>
      }>
      <form id="invite-member" className="settings-dialog-form" onSubmit={handleSubmit} noValidate>
        <Input label="Email" type="email" placeholder="name@company.com" value={email} onChange={(event) => setEmail(event.target.value)} error={error} />
        <Select label="Role" items={roleItems} value={selectedRoleId} onValueChange={setRoleId} />
      </form>
    </Dialog>
  );
};

export default InviteMemberDialog;
